import { Staff } from './staff.model'

export enum InsOperation {
  GET_INS_WITH_CARD = 'GET_INS_WITH_CARD',
  GET_INS_WITHOUT_CARD = 'GET_INS_WITHOUT_CARD',
  CHECK_INS_IDENTITY = 'CHECK_INS_IDENTITY',
  ACCESS_PATIENT_RECORD = 'ACCESS_PATIENT_RECORD',
  UPDATE_PATIENT_IDENTITY = 'UPDATE_PATIENT_IDENTITY',
  RECEIVE_EXTERNAL_IDENTITY = 'RECEIVE_EXTERNAL_IDENTITY',
}

export enum InsIdentityResultCode {
  NO_IDENTITY_FOUND = 1,
  UNIQUE_IDENTITY_FOUND = 2,
  MULTIPLE_IDENTITIES_FOUND = 3,
}

export type InsAuditChangeValue = string | number | boolean | null

export type InsAuditChange = {
  field: string
  before: InsAuditChangeValue
  after: InsAuditChangeValue
}

export type InsAuditReturnedInsHistory = {
  value?: string
  key?: string
  oid?: string
  startDate?: string
  endDate?: string
}

export type InsReturnStatus = 'OK' | 'KO'

export type InsAuditReturnedIdentity = {
  insNIR?: string
  insOID?: string
  birthName?: string
  birthGiven?: string
  birthDate?: string
  sex?: string
  birthPlaceCode?: string
  insHistory?: InsAuditReturnedInsHistory[]
}

export type InsAuditLog = {
  _id: string
  patient?: string
  patientFullName?: string
  patientInsNIR?: string
  patientInsOID?: string
  staff: Staff
  establishment: string
  operation: InsOperation
  resultCode?: InsIdentityResultCode
  changes?: InsAuditChange[]
  returnedIdentity?: InsAuditReturnedIdentity
  returnStatus?: InsReturnStatus
  emitter?: string
  receivedIdentity?: InsAuditReturnedIdentity
  createdAt: Date
}

export type CreateInsAuditLogDto = {
  patient?: string
  patientFullName?: string
  operation: InsOperation
  resultCode?: InsIdentityResultCode
  returnedIdentity?: InsAuditReturnedIdentity
  returnStatus?: InsReturnStatus
  emitter?: string
  receivedIdentity?: InsAuditReturnedIdentity
}
